export default {
  fr: {
    title: 'Actualités',
    seeAll: 'Voir tout',
  },
  en: {
    title: 'News',
    seeAll: 'See all',
  },
  'pt-br': {
    title: 'Notícias',
    seeAll: 'Ver tudo',
  },
  es: {
    title: 'Noticias',
    seeAll: 'Ver todos',
  },
  de: {
    title: 'Nachrichten',
    seeAll: 'Alles ansehen',
  },
} as const
